module.exports = __webpack_public_path__ + "img/Nyromantikk_Massemedier_Grammofon.edd10fb7.jpg";